export default __webpack_public_path__ + "static/media/sunil.327a83e7.png";